import axios from 'axios'
import { push } from 'react-router-redux'
import { change } from 'redux-form'
import reduce from 'lodash/reduce'
import { createFlash, createError } from './flasher'

const baseAPI = process.env.REACT_APP_BASE_API

export const fetchCertificates = (id, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: 'FETCH_CERTIFICATES_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${id}/certificates`
    }).then((x) => {
      dispatch({
        type: 'FETCH_CERTIFICATES_FULFILLED',
        payload: {
          data: x.data,
          pagination: {
            currentPage: x.headers['x-pagination-current-page'],
            pageCount: x.headers['x-pagination-page-count'],
            perPage: x.headers['x-pagination-per-page'],
            totalCount: x.headers['x-pagination-total-count']
          }
        }
      })
    }).catch((e) => {
      dispatch({
        type: 'FETCH_CERTIFICATES_REJECTED',
        payload: e
      })
    })
  }
}

export const fetchGlobalCertificates = (query = '', accessToken) => {
  const queryString = typeof query === 'object'
    ? reduce(query, (x, val, key) => (
      x + key + '=' + val + '&'
    ), '')
    : query
  return (dispatch) => {
    dispatch({
      type: 'FETCH_GLOBAL_CERTIFICATES_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/certificates${queryString}`
    }).then((x) => {
      dispatch({
        type: 'FETCH_GLOBAL_CERTIFICATES_FULFILLED',
        payload: {
          data: x.data,
          pagination: {
            currentPage: x.headers['x-pagination-current-page'],
            pageCount: x.headers['x-pagination-page-count'],
            perPage: x.headers['x-pagination-per-page'],
            totalCount: x.headers['x-pagination-total-count']
          }
        }
      })
    }).catch((e) => {
      console.error(e)
      dispatch(createError(e?.response?.data || 'Error 12421'))
      dispatch({
        type: 'FETCH_GLOBAL_CERTIFICATES_REJECTED',
        payload: e
      })
    })
  }
}

export const fetchCertificate = (orderId, id, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: 'FETCH_CERTIFICATE_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${orderId}/certificates/${id}`
    }).then((x) => {
      dispatch({
        type: 'FETCH_CERTIFICATE_FULFILLED',
        payload: x.data
      })
    }).catch((e) => {
      dispatch({
        type: 'FETCH_CERTIFICATE_REJECTED',
        payload: e
      })
    })
  }
}

export const createCertificate = (data, accessToken, target) => {
  return (dispatch) => {
    dispatch({
      type: 'CREATE_CERTIFICATE_PENDING'
    })
    return axios({
      data,
      method: 'post',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${data.order_id}/certificates`
    }).then((x) => {
      dispatch({
        type: 'CREATE_CERTIFICATE_FULFILLED',
        payload: x.data
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'success',
        message: `Certificate created with the id ${x.data.id}`
      }))
      if (target) {
        dispatch(change(target.form, target.field, {
          value: x.data.id,
          label: x.data.name
        }))
      } else {
        dispatch(push(`/orders/${x.data.order.id}/certificates/${x.data.id}`))
      }
    }).catch((e) => {
      dispatch({
        type: 'CREATE_CERTIFICATE_REJECTED',
        payload: e
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'error',
        message: `Update error`
      }))
    })
  }
}

export const updateCertificate = (data, accessToken, target) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_CERTIFICATE_PENDING'
    })
    return axios({
      data,
      method: 'put',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${data.order_id}/certificates/${data.id}`
    }).then((x) => {
      dispatch({
        type: 'UPDATE_CERTIFICATE_FULFILLED',
        payload: x.data
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'success',
        message: `Report with the id ${x.data.id} updated`
      }))
      if (target) {
        dispatch(push(target))
      }
    }).catch((e) => {
      dispatch({
        type: 'UPDATE_CERTIFICATE_REJECTED',
        payload: e
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'error',
        message: `Update error`
      }))
    })
  }
}

export const getValidity = ({number, uuid}) => {
  return axios({
    method: 'GET',
    url: `${baseAPI}/validity?number=${number}&uuid=${uuid}`
  });
}
